module.exports = __webpack_public_path__ + "img/hr-sand-rock-small-12.0767facf.png";